const Section = ({ eyebrow, title, description, action, children }) => (
  <div className="section pb-4 mb-4 border-bottom">
    <div className="mb-3 d-flex flex-wrap justify-content-between align-items-start gap-2">
      <div>
        {eyebrow && <p className="eyebrow text-uppercase text-primary fw-semibold mb-1 small">{eyebrow}</p>}
        {title && <h2 className="h5 mb-1">{title}</h2>}
        {description && <p className="text-muted mb-0">{description}</p>}
      </div>
      {action && <div className="ms-md-auto">{action}</div>}
    </div>
    {children}
  </div>
);

export default Section;
